import React from "react";
import { LinkAnchor } from "@Components/Common/CommonMethods";
import { useRouter } from "next/router";
import Cookies from "js-cookie";

const ThreeContainerSection = ({ setOpenKitAncestry, handleAddKitProduct, FormulahandleAddKitProduct, FormulahandleAddKitProductAncestry }) => {
   const router = useRouter();
   return (
      <>
         <div className="main-three-container-section">
            <div className="andme-first-section box-content-section">
               <h2>23&Me</h2>
               <p>Simple easy-to-follow instructions to turn cryptic DNA data into a personalized nutritional recipe unlocking your full health potential. </p>
               <div className="get-nutritional-code">
                  <a className="get-nutritional-code-button" onClick={() => setOpenKitAncestry(true)}>Press to Get Your Nutritional Code Now
                     <span>Enter DNA data from 23andMe only</span>
                  </a>
               </div>

            </div>
            <div className="andme-second-section box-content-section ">
               <h2 style={{ color: "#fff" }}>Ancestry & Other</h2>
               <p>Simple easy-to-follow instructions to turn cryptic DNA data into a personalized nutritional recipe unlocking your full health potential.</p>
               <div className="get-nutritional-code">
                  <a className="get-nutritional-code-button" onClick={() => {
                     setOpenKitAncestry(true), Cookies.set("ancestryon", true, { expires: 30 / 86400 });
                  }}> Press to Get Your Nutritional Code Now
                     <span>Enter DNA data from Ancestry.com & other sources</span>
                  </a>

               </div>
            </div>
         </div>
      </>

   )
}
export default ThreeContainerSection;